import { render, staticRenderFns } from "./FamilyDataContacts.vue?vue&type=template&id=0a1f79f9&scoped=true&"
import script from "./FamilyDataContacts.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataContacts.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataContacts.vue?vue&type=style&index=0&id=0a1f79f9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f79f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VLayout,VSpacer,VTooltip})
